import React from "react";

import "./styles.css";

/**
 * @function LoginWrapper
 * @returns {React.Component}
 * @exported true
 * @description The is the iframe wrapper that will pull in, specifically, MABI23 pages and does not have a BottomNavView.
 */
export default function LoginWrapper(props) {
  return (
    <div className="login-wrapper">
      {props.children}
    </div>
  );
}